import { apiClient } from "@/shared/api/api-client"
import { ConfigStore } from "@/shared/model/store"

export const getIpfsConfig = async () => {
    const { setLocalGateway, localGateway, setLocalGatewayPort } = ConfigStore.getState()
    if(!localGateway.url || !localGateway.enable) false
    let url = localGateway.url + '/api/v0/config/show'
    const isLocalhost = localGateway.url.includes('localhost')
    if(isLocalhost) {
        url = localGateway.url + '/api/v0/config/show'
    }
    const response = await apiClient.post<any, any>(url, {})
    if (response.ok && response.data.Addresses?.Gateway) {
			const port = extractPortFromAddress(response.data.Addresses.Gateway)

      setLocalGatewayPort(port?.toString() || '')
			setLocalGateway({
				...localGateway,
        error: '',
				on_air: true,
				ipfs_link: localGateway.url.split(':').slice(0, -1).join(':') + ':' + port + '/ipfs/'
			})
		} else {
			setLocalGatewayPort('')
      setLocalGateway({
				...localGateway,
				on_air: false,
				ipfs_link: '',
        error: 'IPFS is not running'
			})
		}
}

export function extractPortFromAddress(address) {
  // Регулярное выражение для поиска номера порта после /tcp/
  const portRegex = /\/tcp\/(\d+)/;
  
  // Ищем совпадение в строке
  const match = address.match(portRegex);
  
  // Если совпадение найдено, возвращаем номер порта как число
  if (match && match[1]) {
    return parseInt(match[1], 10);
  }
  
  // Если порт не найден, возвращаем null или бросаем ошибку
  return null;
}